import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationAssetsNotShippedDto extends IGetNotification {
    notificationType: NotificationType.assetsNotShipped
    reservationId: Guid
    reservationNumber?: string
    transports: IGetNotificationAssetsNotShippedTransportDto[]
}

export default class NotificationAssetsNotShipped extends Notification {
    reservationId: Guid
    reservationNumber?: string
    transports: NotificationAssetsNotShippedTransport[]

    constructor(dto: IGetNotificationAssetsNotShippedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.transports = dto.transports.map(transprortDto => {
            return new NotificationAssetsNotShippedTransport(transprortDto)
        })
    }
}

interface IGetNotificationAssetsNotShippedTransportDto {
    comment?: string | null
    assets: Guid[]
    manualPositions: string[]
}

export class NotificationAssetsNotShippedTransport {
    comment?: string
    assetIds: Guid[]
    assets: NotificationAsset[]
    manualPositions: string[]

    constructor(dto: IGetNotificationAssetsNotShippedTransportDto) {
        this.comment = dto.comment || undefined
        this.assetIds = dto.assets
        this.assets = dto.assets.map(assetId => {
            return new NotificationAsset({
                assetId,
            })
        })
        this.manualPositions = dto.manualPositions
    }
}
